import { createCrudActions } from "../utils/crudGenerator";

const formatRounds = (data) => {
  if (!data) {
    return [];
  }
  const formatItem = (item) => ({
    ...item,
    label: `${item.roundNumber}`,
    value: item._id,
  });

  if (Array.isArray(data)) {
    return data.map(formatItem);
  }
  return formatItem(data);
};

export const {
  fetch: fetchRounds,
  create: createRound,
  update: updateRound,
  delete: deleteRounds,
} = createCrudActions("ROUND", "Ronda", formatRounds);
